import { API } from "aws-amplify";

export const GET_UNIT_UPGRADES_REQUEST =
  "@@unitUpgradeVersion/GET_UNIT_UPGRADES_REQUEST";
export const GET_UNIT_UPGRADES_SUCCESS =
  "@@unitUpgradeVersion/GET_UNIT_UPGRADES_SUCCESS";
export const GET_UNIT_UPGRADES_FAILURE =
  "@@unitUpgradeVersion/GET_UNIT_UPGRADES_FAILURE";

export function getUnitUpgrades(id) {
  return async (dispatch) => {
    dispatch({ type: GET_UNIT_UPGRADES_REQUEST });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/upgrade`);
      dispatch({
        type: GET_UNIT_UPGRADES_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_UNIT_UPGRADES_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_UNIT_VERSION_REQUEST =
  "@@unitUpgradeVersion/GET_UNIT_VERSION_REQUEST";
export const GET_UNIT_VERSION_SUCCESS =
  "@@unitUpgradeVersion/GET_UNIT_VERSION_SUCCESS";
export const GET_UNIT_VERSION_FAILURE =
  "@@unitUpgradeVersion/GET_UNIT_VERSION_FAILURE";

export function getUnitVersion(id) {
  return async (dispatch) => {
    dispatch({ type: GET_UNIT_VERSION_REQUEST });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/version`);
      dispatch({
        type: GET_UNIT_VERSION_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_UNIT_VERSION_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_UNIT_UPGRADE_VERSION =
  "@@unitUpgradeVersion/CLEAR_UNIT_UPGRADE_VERSION";

export function clearUnitUpgradeVersion() {
  return { type: CLEAR_UNIT_UPGRADE_VERSION };
}
